import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IGameStatus {
	listed: boolean;
}

export const GameStatus: FC<IGameStatus> = ({ listed }) => {
	const { t } = useTranslation();

	return (
		<Box
			padding="4px 8px 2px"
			bg={listed ? 'cartridge.red' : '#555'}
			fontWeight="bold"
			fontSize="10px"
			borderRadius="2px"
		>
			{listed ? t('yourGames.status.accepted') : t('yourGames.status.review')}
		</Box>
	);
};
